import axios from 'axios'

import { SERVICE_END_POINT } from 'Backend'
import { getFreshToken } from './firebaseAuth'

const APIInstance = axios.create({
  baseURL: SERVICE_END_POINT,
  headers: {
    'Content-Type': 'application/json',
  },
})

// A 401 can come from a stale/expired cached ID token rather than a genuinely
// invalid session (common for multi-tenant users switching tenants). Force a
// token refresh and retry the request once before the error reaches handleCatch,
// which logs the user out. A genuinely invalid token still 401s on retry and logs out.
APIInstance.interceptors.response.use(
  response => response,
  async error => {
    const { config, response } = error
    if (response?.status === 401 && config && !config.retryAttempted) {
      config.retryAttempted = true
      let token
      try {
        token = await getFreshToken()
      } catch {
        // If the refresh itself fails, reject with the original error so
        // handleCatch still logs the user out instead of swallowing the 401.
        return Promise.reject(error)
      }
      if (token) {
        config.headers = { ...config.headers, Authorization: `Bearer ${token}` }
      }
      return APIInstance(config)
    }

    return Promise.reject(error)
  }
)

export const APIInstancePublic = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API_PUBLIC_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default APIInstance
